const utils = require('base_global/utils');
var didScroll;
var inCorrectUrl;
var languageSelectorObjectsMobile;
var enableFooterLanguageSelector;
var enableHeaderLanguageSelector;
/**
 * Function select language
 */
function hasScrolled() {
    var lastScrollTop = 0;
    var navbarHeight = $('.js-globalnav-header').outerHeight();
    var scrollTop = $(window).scrollTop();
    var footComp = $('#footercontent');
    var $langPopover = $('.js-lang-dropdown');
    var $arrowUp = $('.js-lang-btn .icon-utility-chevron-16px-up');
    var $arrowDown = $('.js-lang-btn .icon-utility-chevron-16px-down');
    if (scrollTop > lastScrollTop && scrollTop > navbarHeight && scrollTop > 100) {
        $langPopover.addClass('d-none-popover');
        $arrowUp.addClass('d-none');
        $arrowDown.removeClass('d-none');
    } else if (utils.isInViewport(footComp)) {
        if ((scrollTop + $(window).height() < $(document).height()) && scrollTop > 40) {
            $langPopover.addClass('d-none-popover');
            $arrowUp.addClass('d-none');
            $arrowDown.removeClass('d-none');
        }
    }
}
/**
 * Function to render languages list
 */
function renderLanguageList(preferredLanguagesId, enableHeaderLanguageSelector, enableFooterLanguageSelector) {
    var $langPopover = $('.js-lang-dropdown');
    var preferredLanguagesValue = preferredLanguagesId.value;
    var preferredLanguagesObject = JSON.parse(preferredLanguagesValue);
    var currentUrl = window.location.href;
    var languageSelectorObjectsDesktop = [];
    languageSelectorObjectsMobile = [];
    var counter = 0;
    inCorrectUrl = false;

    for (let key in preferredLanguagesObject) { //eslint-disable-line
        //looping to check the url has the preffered language from site pref, if it has then create link and label for all languages in site pref
        var preferredLanguage = key.trim();
        var checkIfUrlHasthePrefferedLanguage = currentUrl.split('/').includes(preferredLanguage) || window.location.pathname.split('/').includes(preferredLanguage);
        if (checkIfUrlHasthePrefferedLanguage) {
            var languageFromUrl = preferredLanguage.toUpperCase();
            var showSelectedLanguage;
            if (preferredLanguagesId.className !== 'language-list-footer-check') {
                $('.show-selected-language').text(languageFromUrl);
                showSelectedLanguage = $('.show-selected-language')[0];
            }
            // loop through preferredLanguages and replace the link and label for all languages
            for (let keyValue in preferredLanguagesObject) { //eslint-disable-line
                var value = keyValue.trim();
                var replacelanguage = value;
                var languageSelectorObject = {};
                var languageSelectorObjectFooter = {};
                var replaceUrl = currentUrl.replace(preferredLanguage, replacelanguage);
                languageSelectorObject.labelHeader = preferredLanguagesObject[value][0];
                languageSelectorObject.labelFooter = preferredLanguagesObject[value][1];
                languageSelectorObject.link = replaceUrl;
                // Sanitize the label to prevent XSS
                var sanitizedLabelHeader = $('<div>').text(languageSelectorObject.labelHeader).html();
                var sanitizedLabelFooter = $('<div>').text(languageSelectorObject.labelFooter).html();
                var sanitizedLink = $('<div>').text(languageSelectorObject.link).html();

                // HTML for both header mobile version and Footer
                var selectedLanguageMobile = sanitizedLabelHeader === languageFromUrl ? 'selected-language' : '';
                languageSelectorObjectFooter.label = sanitizedLabelFooter;
                var htmlMobileAndFooter = '<span class="lang-list"><a class="' + selectedLanguageMobile + '" href="' + sanitizedLink + '" role="button" aria-label="' + sanitizedLabelFooter + '" tabindex="-1">' + sanitizedLabelFooter + '</a></span>';
                languageSelectorObjectsMobile.push(htmlMobileAndFooter);
                if (enableHeaderLanguageSelector.value === 'true') {
                    var showSelectedIcon = showSelectedLanguage.innerText === sanitizedLabelHeader ? 'd-inline-block' : 'd-none';
                    var showSelectedLanguageLabel = showSelectedLanguage.innerText === sanitizedLabelHeader ? 'icon-checkmark selected-language' : 'language-list-spacing';
                    var htmlDesktop = '<div class="login-acc-container"><a role="button" class="lang-link ' + showSelectedLanguageLabel + '" href="' + sanitizedLink + '" aria-label="' + sanitizedLabelHeader + '" tabindex="-1"><span class="user-message">' + sanitizedLabelHeader + '</span></a></div>';
                    languageSelectorObjectsDesktop.push(htmlDesktop);
                }
            }
        } else {
            // to check if the Url does not contain the required language keys
            counter++;
            if (Object.keys(preferredLanguagesObject).length === counter) {
                inCorrectUrl = true;
            }
        }
    }
    if (!inCorrectUrl) {
        if (enableHeaderLanguageSelector.value === 'true') {
            $('.language-selector-wrapper').removeClass('d-none');
            $langPopover.append(languageSelectorObjectsDesktop);
        }
    } else {
        $('.language-selector-wrapper').addClass('d-none');
    }
}

function enableLanguageSelector() {
    var enableLanguageSelector = $('#enableLanguageSelector')[0].value;
    //check if the language selector is enabled
    if (enableLanguageSelector) {
        var preferredLanguagesHeaderId = $('#languagesListHeader')[0];
        enableHeaderLanguageSelector = $('#enableHeaderLanguageSelector')[0];
        enableFooterLanguageSelector = $('#enableFooterLanguageSelector')[0];
        if (typeof preferredLanguagesHeaderId !== 'undefined' && preferredLanguagesHeaderId.value !== 'null') {
            renderLanguageList(preferredLanguagesHeaderId, enableHeaderLanguageSelector, enableFooterLanguageSelector);
            $(window).on('scroll', function () {
                didScroll = true;
            });
            setInterval(function () {
                if (didScroll) {
                    hasScrolled();
                    didScroll = false;
                }
            }, 250);
            $(document).on('click', function (e) {
                var $langPopover = $('.js-lang-dropdown');
                var $arrowUp = $('.js-lang-btn .icon-utility-chevron-16px-up');
                var $arrowDown = $('.js-lang-btn .icon-utility-chevron-16px-down');
                if ($(e.target).parents('.js-acc-btn').length) {
                    $langPopover.addClass('d-none-popover');
                } else if ($(e.target).parents('.js-lang-btn').length) {
                    $langPopover.toggleClass('d-none-popover');
                } else if (!$langPopover.hasClass('d-none-popover')) {
                    $langPopover.addClass('d-none-popover');
                }
                if ($langPopover.hasClass('d-none-popover')) {
                    $arrowUp.addClass('d-none');
                    $arrowDown.removeClass('d-none');
                } else {
                    $arrowUp.removeClass('d-none');
                    $arrowDown.addClass('d-none');
                }
            });
        }
    }
}

/**
 * Function enable language selector in footer
 */
function enableLanguageSelectorFooter() {
    if (!inCorrectUrl) {
        if (enableFooterLanguageSelector && enableFooterLanguageSelector.value === 'true') {
            $('.language-list-footer').removeClass('d-none').append(languageSelectorObjectsMobile);
        }
    } else {
        $('.language-list-footer').addClass('d-none');
    }
}

/**
 * Function enable language selector in Hamburger menu for mobile
 */
function enableLanguageSelectorMobileHamburger() {
    if (!inCorrectUrl) {
        if (enableHeaderLanguageSelector.value === 'true') {
            $('.language-list-mobile').removeClass('d-none').append(languageSelectorObjectsMobile);
        }
    } else {
        $('.language-list-mobile').addClass('d-none');
    }
}

export default {
    init: () => {
        enableLanguageSelector();
        enableLanguageSelectorMobileHamburger();
        if ($('.global-footer__wrapper').length) {
            enableLanguageSelectorFooter();
        } else {
            $('body').on('footer:enabled', function () {
                enableLanguageSelectorFooter();
            });
        }
    }
}
